<div class="pop_mask" *ngIf="open" style="z-index: 10005;">
    <div class="pop_mid" >
        <div class="pop_block">
            <h3 *ngIf="title != ''">{{title}}</h3>
            <div class="pop_content" [innerHTML]="content">
            </div>
            <div class="btn_group" >
                <div class="cancel" (click)="Cancel()" *ngIf="cancelTxt != ''">{{cancelTxt}}</div>
                <div class="check" (click)="Submit()">{{checkTxt}}</div>
            </div>
        </div>
    </div>
</div>